import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Outlet } from 'react-router-dom'
import { setSearchQuery } from '../store/packageManagementSlice'

const initialSearchQuery = {
  "package_code": "",
  "package_name": "",
  "page": 0,
  "size": 5,
  "deployment_system_code": "ViettelMeetingCloud"
}

const LayoutPackageManagement = () => {

  const dispatch = useDispatch()

  useEffect(() => {

    /**
     * Reset query search khi reload trang.
     * Do đang dùng persist
     */
    window.onbeforeunload = function (e) {
      dispatch(setSearchQuery(initialSearchQuery))
    };

    return () => {
      /**
       * Reset query search khi rời tab quản lý gói
       */
      dispatch(setSearchQuery(initialSearchQuery))
    }
  }, [dispatch])

  return (
    <Outlet />
  )
}

export default LayoutPackageManagement